export const phoneCountryCodes = [
  {
    name: 'Antigua and Barbuda',
    label: '🇦🇬 +1',
    value: '+1'
  },
  {
    name: 'Bahamas',
    label: '🇧🇸 +1',
    value: '+1'
  },
  {
    name: 'Barbados',
    label: '🇧🇧 +1',
    value: '+1'
  },
  {
    name: 'Canada',
    label: '🇨🇦 +1',
    value: '+1'
  },
  {
    name: 'United States',
    label: '🇺🇸 +1',
    value: '+1'
  },
  {
    name: 'Grenada',
    label: '🇬🇩 +1-473',
    value: '+1-473'
  },
  {
    name: 'Dominica',
    label: '🇩🇲 +1-767',
    value: '+1-767'
  },
  {
    name: 'Dominican Republic',
    label: '🇩🇴 +1-809, +1-829, +1-849',
    value: '+1-809, +1-829, +1-849'
  },
  {
    name: 'Jamaica',
    label: '🇯🇲 +1-876',
    value: '+1-876'
  },
  {
    name: 'Saint Lucia',
    label: '🇱🇨 +1758',
    value: '+1758'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    label: '🇻🇨 +1784',
    value: '+1784'
  },
  {
    name: 'Trinidad and Tobago',
    label: '🇹🇹 +1868',
    value: '+1868'
  },
  {
    name: 'Saint Kitts and Nevis',
    label: '🇰🇳 +1869',
    value: '+1869'
  },
  {
    name: 'Egypt',
    label: '🇪🇬 +20',
    value: '+20'
  },
  {
    name: 'South Sudan',
    label: '🇸🇸 +211',
    value: '+211'
  },
  {
    name: 'Morocco',
    label: '🇲🇦 +212',
    value: '+212'
  },
  {
    name: 'Algeria',
    label: '🇩🇿 +213',
    value: '+213'
  },
  {
    name: 'Tunisia',
    label: '🇹🇳 +216',
    value: '+216'
  },
  {
    name: 'Libya',
    label: '🇱🇾 +218',
    value: '+218'
  },
  {
    name: 'Gambia',
    label: '🇬🇲 +220',
    value: '+220'
  },
  {
    name: 'Senegal',
    label: '🇸🇳 +221',
    value: '+221'
  },
  {
    name: 'Mauritania',
    label: '🇲🇷 +222',
    value: '+222'
  },
  {
    name: 'Mali',
    label: '🇲🇱 +223',
    value: '+223'
  },
  {
    name: 'Guinea',
    label: '🇬🇳 +224',
    value: '+224'
  },
  {
    name: 'Ivory Coast',
    label: '🇨🇮 +225',
    value: '+225'
  },
  {
    name: 'Burkina Faso',
    label: '🇧🇫 +226',
    value: '+226'
  },
  {
    name: 'Niger',
    label: '🇳🇪 +227',
    value: '+227'
  },
  {
    name: 'Togo',
    label: '🇹🇬 +228',
    value: '+228'
  },
  {
    name: 'Benin',
    label: '🇧🇯 +229',
    value: '+229'
  },
  {
    name: 'Mauritius',
    label: '🇲🇺 +230',
    value: '+230'
  },
  {
    name: 'Liberia',
    label: '🇱🇷 +231',
    value: '+231'
  },
  {
    name: 'Sierra Leone',
    label: '🇸🇱 +232',
    value: '+232'
  },
  {
    name: 'Ghana',
    label: '🇬🇭 +233',
    value: '+233'
  },
  {
    name: 'Nigeria',
    label: '🇳🇬 +234',
    value: '+234'
  },
  {
    name: 'Chad',
    label: '🇹🇩 +235',
    value: '+235'
  },
  {
    name: 'Central African Republic',
    label: '🇨🇫 +236',
    value: '+236'
  },
  {
    name: 'Cameroon',
    label: '🇨🇲 +237',
    value: '+237'
  },
  {
    name: 'Cape Verde',
    label: '🇨🇻 +238',
    value: '+238'
  },
  {
    name: 'Sao Tome and Principe',
    label: '🇸🇹 +239',
    value: '+239'
  },
  {
    name: 'Equatorial Guinea',
    label: '🇬🇶 +240',
    value: '+240'
  },
  {
    name: 'Gabon',
    label: '🇬🇦 +241',
    value: '+241'
  },
  {
    name: 'Congo (Congo-Brazzaville)',
    label: '🇨🇬 +242',
    value: '+242'
  },
  {
    name: 'Democratic Republic of the Congo',
    label: '🇨🇩 +243',
    value: '+243'
  },
  {
    name: 'Angola',
    label: '🇦🇴 +244',
    value: '+244'
  },
  {
    name: 'Guinea-Bissau',
    label: '🇬🇼 +245',
    value: '+245'
  },
  {
    name: 'Seychelles',
    label: '🇸🇨 +248',
    value: '+248'
  },
  {
    name: 'Sudan',
    label: '🇸🇩 +249',
    value: '+249'
  },
  {
    name: 'Rwanda',
    label: '🇷🇼 +250',
    value: '+250'
  },
  {
    name: 'Ethiopia',
    label: '🇪🇹 +251',
    value: '+251'
  },
  {
    name: 'Somalia',
    label: '🇸🇴 +252',
    value: '+252'
  },
  {
    name: 'Djibouti',
    label: '🇩🇯 +253',
    value: '+253'
  },
  {
    name: 'Kenya',
    label: '🇰🇪 +254',
    value: '+254'
  },
  {
    name: 'Tanzania',
    label: '🇹🇿 +255',
    value: '+255'
  },
  {
    name: 'Uganda',
    label: '🇺🇬 +256',
    value: '+256'
  },
  {
    name: 'Burundi',
    label: '🇧🇮 +257',
    value: '+257'
  },
  {
    name: 'Mozambique',
    label: '🇲🇿 +258',
    value: '+258'
  },
  {
    name: 'Zambia',
    label: '🇿🇲 +260',
    value: '+260'
  },
  {
    name: 'Madagascar',
    label: '🇲🇬 +261',
    value: '+261'
  },
  {
    name: 'Zimbabwe',
    label: '🇿🇼 +263',
    value: '+263'
  },
  {
    name: 'Namibia',
    label: '🇳🇦 +264',
    value: '+264'
  },
  {
    name: 'Malawi',
    label: '🇲🇼 +265',
    value: '+265'
  },
  {
    name: 'Lesotho',
    label: '🇱🇸 +266',
    value: '+266'
  },
  {
    name: 'Botswana',
    label: '🇧🇼 +267',
    value: '+267'
  },
  {
    name: 'Eswatini',
    label: '🇸🇿 +268',
    value: '+268'
  },
  {
    name: 'Comoros',
    label: '🇰🇲 +269',
    value: '+269'
  },
  {
    name: 'South Africa',
    label: '🇿🇦 +27',
    value: '+27'
  },
  {
    name: 'Eritrea',
    label: '🇪🇷 +291',
    value: '+291'
  },
  {
    name: 'Greece',
    label: '🇬🇷 +30',
    value: '+30'
  },
  {
    name: 'Netherlands',
    label: '🇳🇱 +31',
    value: '+31'
  },
  {
    name: 'Belgium',
    label: '🇧🇪 +32',
    value: '+32'
  },
  {
    name: 'France',
    label: '🇫🇷 +33',
    value: '+33'
  },
  {
    name: 'Spain',
    label: '🇪🇸 +34',
    value: '+34'
  },
  {
    name: 'Portugal',
    label: '🇵🇹 +351',
    value: '+351'
  },
  {
    name: 'Luxembourg',
    label: '🇱🇺 +352',
    value: '+352'
  },
  {
    name: 'Ireland',
    label: '🇮🇪 +353',
    value: '+353'
  },
  {
    name: 'Iceland',
    label: '🇮🇸 +354',
    value: '+354'
  },
  {
    name: 'Albania',
    label: '🇦🇱 +355',
    value: '+355'
  },
  {
    name: 'Malta',
    label: '🇲🇹 +356',
    value: '+356'
  },
  {
    name: 'Cyprus',
    label: '🇨🇾 +357',
    value: '+357'
  },
  {
    name: 'Finland',
    label: '🇫🇮 +358',
    value: '+358'
  },
  {
    name: 'Bulgaria',
    label: '🇧🇬 +359',
    value: '+359'
  },
  {
    name: 'Hungary',
    label: '🇭🇺 +36',
    value: '+36'
  },
  {
    name: 'Lithuania',
    label: '🇱🇹 +370',
    value: '+370'
  },
  {
    name: 'Latvia',
    label: '🇱🇻 +371',
    value: '+371'
  },
  {
    name: 'Estonia',
    label: '🇪🇪 +372',
    value: '+372'
  },
  {
    name: 'Moldova',
    label: '🇲🇩 +373',
    value: '+373'
  },
  {
    name: 'Armenia',
    label: '🇦🇲 +374',
    value: '+374'
  },
  {
    name: 'Belarus',
    label: '🇧🇾 +375',
    value: '+375'
  },
  {
    name: 'Andorra',
    label: '🇦🇩 +376',
    value: '+376'
  },
  {
    name: 'Monaco',
    label: '🇲🇨 +377',
    value: '+377'
  },
  {
    name: 'San Marino',
    label: '🇸🇲 +378',
    value: '+378'
  },
  {
    name: 'Vatican City',
    label: '🇻🇦 +379',
    value: '+379'
  },
  {
    name: 'Ukraine',
    label: '🇺🇦 +380',
    value: '+380'
  },
  {
    name: 'Serbia',
    label: '🇷🇸 +381',
    value: '+381'
  },
  {
    name: 'Montenegro',
    label: '🇲🇪 +382',
    value: '+382'
  },
  {
    name: 'Kosovo',
    label: '🇽🇰 +383',
    value: '+383'
  },
  {
    name: 'Croatia',
    label: '🇭🇷 +385',
    value: '+385'
  },
  {
    name: 'Slovenia',
    label: '🇸🇮 +386',
    value: '+386'
  },
  {
    name: 'Bosnia and Herzegovina',
    label: '🇧🇦 +387',
    value: '+387'
  },
  {
    name: 'North Macedonia',
    label: '🇲🇰 +389',
    value: '+389'
  },
  {
    name: 'Italy',
    label: '🇮🇹 +39',
    value: '+39'
  },
  {
    name: 'Romania',
    label: '🇷🇴 +40',
    value: '+40'
  },
  {
    name: 'Switzerland',
    label: '🇨🇭 +41',
    value: '+41'
  },
  {
    name: 'Czech Republic',
    label: '🇨🇿 +420',
    value: '+420'
  },
  {
    name: 'Slovakia',
    label: '🇸🇰 +421',
    value: '+421'
  },
  {
    name: 'Liechtenstein',
    label: '🇱🇮 +423',
    value: '+423'
  },
  {
    name: 'Austria',
    label: '🇦🇹 +43',
    value: '+43'
  },
  {
    name: 'United Kingdom',
    label: '🇬🇧 +44',
    value: '+44'
  },
  {
    name: 'Denmark',
    label: '🇩🇰 +45',
    value: '+45'
  },
  {
    name: 'Sweden',
    label: '🇸🇪 +46',
    value: '+46'
  },
  {
    name: 'Norway',
    label: '🇳🇴 +47',
    value: '+47'
  },
  {
    name: 'Poland',
    label: '🇵🇱 +48',
    value: '+48'
  },
  {
    name: 'Germany',
    label: '🇩🇪 +49',
    value: '+49'
  },
  {
    name: 'Belize',
    label: '🇧🇿 +501',
    value: '+501'
  },
  {
    name: 'Guatemala',
    label: '🇬🇹 +502',
    value: '+502'
  },
  {
    name: 'El Salvador',
    label: '🇸🇻 +503',
    value: '+503'
  },
  {
    name: 'Honduras',
    label: '🇭🇳 +504',
    value: '+504'
  },
  {
    name: 'Nicaragua',
    label: '🇳🇮 +505',
    value: '+505'
  },
  {
    name: 'Costa Rica',
    label: '🇨🇷 +506',
    value: '+506'
  },
  {
    name: 'Panama',
    label: '🇵🇦 +507',
    value: '+507'
  },
  {
    name: 'Haiti',
    label: '🇭🇹 +509',
    value: '+509'
  },
  {
    name: 'Peru',
    label: '🇵🇪 +51',
    value: '+51'
  },
  {
    name: 'Mexico',
    label: '🇲🇽 +52',
    value: '+52'
  },
  {
    name: 'Cuba',
    label: '🇨🇺 +53',
    value: '+53'
  },
  {
    name: 'Argentina',
    label: '🇦🇷 +54',
    value: '+54'
  },
  {
    name: 'Brazil',
    label: '🇧🇷 +55',
    value: '+55'
  },
  {
    name: 'Chile',
    label: '🇨🇱 +56',
    value: '+56'
  },
  {
    name: 'Colombia',
    label: '🇨🇴 +57',
    value: '+57'
  },
  {
    name: 'Venezuela',
    label: '🇻🇪 +58',
    value: '+58'
  },
  {
    name: 'Bolivia',
    label: '🇧🇴 +591',
    value: '+591'
  },
  {
    name: 'Guyana',
    label: '🇬🇾 +592',
    value: '+592'
  },
  {
    name: 'Ecuador',
    label: '🇪🇨 +593',
    value: '+593'
  },
  {
    name: 'Paraguay',
    label: '🇵🇾 +595',
    value: '+595'
  },
  {
    name: 'Suriname',
    label: '🇸🇷 +597',
    value: '+597'
  },
  {
    name: 'Uruguay',
    label: '🇺🇾 +598',
    value: '+598'
  },
  {
    name: 'Malaysia',
    label: '🇲🇾 +60',
    value: '+60'
  },
  {
    name: 'Australia',
    label: '🇦🇺 +61',
    value: '+61'
  },
  {
    name: 'Indonesia',
    label: '🇮🇩 +62',
    value: '+62'
  },
  {
    name: 'Philippines',
    label: '🇵🇭 +63',
    value: '+63'
  },
  {
    name: 'New Zealand',
    label: '🇳🇿 +64',
    value: '+64'
  },
  {
    name: 'Singapore',
    label: '🇸🇬 +65',
    value: '+65'
  },
  {
    name: 'Thailand',
    label: '🇹🇭 +66',
    value: '+66'
  },
  {
    name: 'Timor-Leste',
    label: '🇹🇱 +670',
    value: '+670'
  },
  {
    name: 'Brunei',
    label: '🇧🇳 +673',
    value: '+673'
  },
  {
    name: 'Nauru',
    label: '🇳🇷 +674',
    value: '+674'
  },
  {
    name: 'Papua New Guinea',
    label: '🇵🇬 +675',
    value: '+675'
  },
  {
    name: 'Tonga',
    label: '🇹🇴 +676',
    value: '+676'
  },
  {
    name: 'Solomon Islands',
    label: '🇸🇧 +677',
    value: '+677'
  },
  {
    name: 'Vanuatu',
    label: '🇻🇺 +678',
    value: '+678'
  },
  {
    name: 'Fiji',
    label: '🇫🇯 +679',
    value: '+679'
  },
  {
    name: 'Palau',
    label: '🇵🇼 +680',
    value: '+680'
  },
  {
    name: 'Samoa',
    label: '🇼🇸 +685',
    value: '+685'
  },
  {
    name: 'Kiribati',
    label: '🇰🇮 +686',
    value: '+686'
  },
  {
    name: 'Tuvalu',
    label: '🇹🇻 +688',
    value: '+688'
  },
  {
    name: 'Micronesia',
    label: '🇫🇲 +691',
    value: '+691'
  },
  {
    name: 'Marshall Islands',
    label: '🇲🇭 +692',
    value: '+692'
  },
  {
    name: 'Kazakhstan',
    label: '🇰🇿 +7',
    value: '+7'
  },
  {
    name: 'Russia',
    label: '🇷🇺 +7',
    value: '+7'
  },
  {
    name: 'Japan',
    label: '🇯🇵 +81',
    value: '+81'
  },
  {
    name: 'South Korea',
    label: '🇰🇷 +82',
    value: '+82'
  },
  {
    name: 'Vietnam',
    label: '🇻🇳 +84',
    value: '+84'
  },
  {
    name: 'North Korea',
    label: '🇰🇵 +850',
    value: '+850'
  },
  {
    name: 'Hong Kong',
    label: '🇭🇰 +852',
    value: '+852'
  },
  {
    name: 'Cambodia',
    label: '🇰🇭 +855',
    value: '+855'
  },
  {
    name: 'Laos',
    label: '🇱🇦 +856',
    value: '+856'
  },
  {
    name: 'China',
    label: '🇨🇳 +86',
    value: '+86'
  },
  {
    name: 'Bangladesh',
    label: '🇧🇩 +880',
    value: '+880'
  },
  {
    name: 'Taiwan',
    label: '🇹🇼 +886',
    value: '+886'
  },
  {
    name: 'Turkey',
    label: '🇹🇷 +90',
    value: '+90'
  },
  {
    name: 'India',
    label: '🇮🇳 +91',
    value: '+91'
  },
  {
    name: 'Pakistan',
    label: '🇵🇰 +92',
    value: '+92'
  },
  {
    name: 'Afghanistan',
    label: '🇦🇫 +93',
    value: '+93'
  },
  {
    name: 'Sri Lanka',
    label: '🇱🇰 +94',
    value: '+94'
  },
  {
    name: 'Myanmar',
    label: '🇲🇲 +95',
    value: '+95'
  },
  {
    name: 'Maldives',
    label: '🇲🇻 +960',
    value: '+960'
  },
  {
    name: 'Lebanon',
    label: '🇱🇧 +961',
    value: '+961'
  },
  {
    name: 'Jordan',
    label: '🇯🇴 +962',
    value: '+962'
  },
  {
    name: 'Syria',
    label: '🇸🇾 +963',
    value: '+963'
  },
  {
    name: 'Iraq',
    label: '🇮🇶 +964',
    value: '+964'
  },
  {
    name: 'Kuwait',
    label: '🇰🇼 +965',
    value: '+965'
  },
  {
    name: 'Saudi Arabia',
    label: '🇸🇦 +966',
    value: '+966'
  },
  {
    name: 'Yemen',
    label: '🇾🇪 +967',
    value: '+967'
  },
  {
    name: 'Oman',
    label: '🇴🇲 +968',
    value: '+968'
  },
  {
    name: 'United Arab Emirates',
    label: '🇦🇪 +971',
    value: '+971'
  },
  {
    name: 'Israel',
    label: '🇮🇱 +972',
    value: '+972'
  },
  {
    name: 'Bahrain',
    label: '🇧🇭 +973',
    value: '+973'
  },
  {
    name: 'Qatar',
    label: '🇶🇦 +974',
    value: '+974'
  },
  {
    name: 'Bhutan',
    label: '🇧🇹 +975',
    value: '+975'
  },
  {
    name: 'Mongolia',
    label: '🇲🇳 +976',
    value: '+976'
  },
  {
    name: 'Nepal',
    label: '🇳🇵 +977',
    value: '+977'
  },
  {
    name: 'Iran',
    label: '🇮🇷 +98',
    value: '+98'
  },
  {
    name: 'Tajikistan',
    label: '🇹🇯 +992',
    value: '+992'
  },
  {
    name: 'Turkmenistan',
    label: '🇹🇲 +993',
    value: '+993'
  },
  {
    name: 'Azerbaijan',
    label: '🇦🇿 +994',
    value: '+994'
  },
  {
    name: 'Georgia',
    label: '🇬🇪 +995',
    value: '+995'
  },
  {
    name: 'Kyrgyzstan',
    label: '🇰🇬 +996',
    value: '+996'
  },
  {
    name: 'Uzbekistan',
    label: '🇺🇿 +998',
    value: '+998'
  }
];
